$.fn.VideoLoop = function() {
  let self = this
  let video = $(this).find('video')

  if (video.data('loaded')) {
    setTimeout(function() {
      picture(video.get(0))
      video.get(0).play()
    }, 60)
  } else {
    video.on('canplaythrough', function() {
      picture(video.get(0))
      video.get(0).play()
    })
  }
}
